import styled, { css } from 'styled-components';

import ImageMrzTwoLineGuide from 'images/pictographs/mrz-two-line-outline.svg';

const Positioner = styled('div')<{ hideGuide: boolean; mirrored: boolean }>`
  position: relative;
  left: 0;
  right: 0;
  top: 100%;
  bottom: 100%;

  ${({ mirrored }) =>
    mirrored &&
    css`
      transform: scale(-1, 1);
    `};
  visibility: ${({ hideGuide }) => (hideGuide ? 'hidden' : 'visible')};
  width: 100%;
`;

interface MrzTwoLineGuideProps {
  mirrored?: boolean;
  hideGuide?: boolean;
}

export default function MrzTwoLineGuide({
  mirrored = false,
  hideGuide = false,
}: MrzTwoLineGuideProps) {
  return (
    <Positioner data-test='mrz-two-line-guide' mirrored={mirrored} hideGuide={hideGuide}>
      <ImageMrzTwoLineGuide />
    </Positioner>
  );
}
